import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import api from "@/lib/api";
import { Badge } from "@/components/common";
import { Building2, ExternalLink, Landmark } from "lucide-react";

export default function PartyProfile() {
  const { id } = useParams();
  const { t } = useTranslation();
  const [p, setP] = useState(null);
  useEffect(() => { api.get(`/parties/${id}`).then((r) => setP(r.data)); }, [id]);
  if (!p) return <p className="text-muted-foreground">{t("Loading…")}</p>;
  return (
    <div className="space-y-6" data-testid="party-page">
      <div className="border border-border bg-white p-8">
        <Building2 className="text-secondary mb-3" size={28} />
        <div className="flex items-center gap-2 mb-1"><h1 className="font-display text-3xl font-extrabold tracking-tight">{p.name}</h1><Badge tone={p.verification_status === "approved" ? "green" : "amber"}>{t(p.verification_status)}</Badge></div>
        <p className="text-muted-foreground mt-1 max-w-2xl">{p.description}</p>
        {p.website && <a href={p.website} target="_blank" rel="noreferrer" className="inline-flex items-center gap-1 text-sm text-primary font-medium mt-2">{p.website} <ExternalLink size={14} /></a>}
      </div>

      <div>
        <h2 className="font-display text-xl font-bold tracking-tight mb-3">{t("Representatives")}</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          {p.representatives.map((r) => <div key={r.id} className="border border-border bg-white p-4"><p className="font-semibold">{r.name}</p><p className="text-xs text-muted-foreground">{t(r.user_type.replace("_", " "))}</p></div>)}
          {p.representatives.length === 0 && <p className="text-sm text-muted-foreground">{t("No representatives linked.")}</p>}
        </div>
      </div>

      <div>
        <h2 className="font-display text-xl font-bold tracking-tight mb-3 flex items-center gap-2"><Landmark size={18} /> {t("Legislative actions")}</h2>
        <div className="space-y-2">
          {p.actions.map((a) => (
            <Link to={`/debates/${a.debate_id}`} key={a.id} className="border border-border bg-white p-4 block hover:shadow-md transition-all" data-testid="party-action-history">
              <div className="flex items-center gap-2 mb-1"><Badge tone="purple">{t(a.action.replace("_", " "))}</Badge><span className="text-xs text-muted-foreground">{a.rep_name}</span></div>
              <p className="font-semibold">{a.debate_title}</p>
              {a.reference && <p className="text-xs text-muted-foreground mt-1">{t("Ref:")} {a.reference}</p>}
              {a.comment && <p className="text-sm text-muted-foreground mt-1">{a.comment}</p>}
            </Link>
          ))}
          {p.actions.length === 0 && <p className="text-sm text-muted-foreground">{t("No actions recorded yet.")}</p>}
        </div>
      </div>
    </div>
  );
}
